import type en from "../en/orders";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  financialPending: "الدفع معلّق",
  financialAwaitingAction: "بانتظار العميل",
  financialAuthorized: "مُصرّح به",
  financialPaid: "مدفوع",
  financialPartiallyRefunded: "مسترد جزئيًا",
  financialRefunded: "مسترد",
  financialFailed: "فشل الدفع",
  financialCancelled: "أُلغي الدفع",
  financialDisputed: "متنازع عليه",
  fulfillmentUnfulfilled: "غير مُنفّذ",
  fulfillmentPartiallyFulfilled: "مُنفّذ جزئيًا",
  fulfillmentFulfilled: "مُنفّذ",
  fulfillmentNotRequired: "بدون شحن",
  orderOpen: "مفتوح",
  orderCompleted: "مكتمل",
  orderCancelled: "ملغى",
  returnRequested: "مطلوب",
  returnApproved: "مقبول",
  returnRejected: "مرفوض",
  returnReceived: "مُستلَم",
  returnRefunded: "مسترد",
  returnClosed: "مغلق",
  paymentPending: "معلّق",
  paymentAwaitingAction: "بانتظار إجراء",
  paymentAuthorized: "مُصرّح به",
  paymentCaptured: "محصّل",
  paymentFailed: "فشل",
  paymentCancelled: "ملغى",
  paymentPartiallyRefunded: "مسترد جزئيًا",
  paymentRefunded: "مسترد",
  paymentDisputed: "متنازع عليه",
  paymentChargeback: "رد مبلغ (Chargeback)",
  shipmentShipped: "تم الشحن",
  shipmentDelivered: "تم التسليم",
  shipmentCancelled: "ملغاة",
  refundSucceeded: "مسترد",
  refundPending: "معلّق لدى مزوّد الدفع",
  refundFailed: "فشل",

  noticePaid: "تم تسجيل الدفعة كمستلَمة. وقد سُجّل ذلك في سجل التدقيق.",
  noticeCancelled: "تم إلغاء الطلب.",
  noticeShipped: "تم إنشاء الشحنة.",
  noticeDelivered: "تم تمييز الشحنة كمُسلَّمة.",
  noticeRefunded: "تم إرسال المبلغ المسترد إلى وسيلة الدفع الأصلية للعميل عبر مزوّد الدفع.",
  noticeRefundedManual: "تم تسجيل الاسترداد. لم يُحوَّل أي مبلغ تلقائيًا — أعِد المبلغ إلى العميل بنفسك.",
  noticeRefundPending: "تم تقديم الاسترداد وهو معلّق لدى المزوّد. استخدم «التحقق من حالة الاسترداد» لتأكيده.",
  noticeRefundCompleted: "تم تأكيد اكتمال الاسترداد المعلّق.",
  noticeReturnApproved: "تمت الموافقة على الإرجاع.",
  noticeReturnRejected: "تم رفض الإرجاع.",
  noticeReturnReceived: "تم تمييز الإرجاع كمُستلَم.",
  noticeReturnClosed: "تم إغلاق الإرجاع.",

  noteAdded: "تمت إضافة الملاحظة.",
  providerUnreachable: "تعذّر الوصول إلى مزوّد الدفع — الاتصال غير موجود أو مقطوع. تحقّق من الإعدادات ← المدفوعات.",
  providerReports: "حالة الدفع لدى المزوّد: {status}.",
  cancelReasonRequired: "أدخل سبب الإلغاء.",
  refundAmountRequired: "أدخل مبلغ الاسترداد.",
  enterAmount: "أدخل مبلغًا",
  refundOfFailed: "فشل استرداد {amount}: {error}. لم يُحوَّل أي مبلغ.",
  refundFailedMsg: "فشل الاسترداد: {error}. لم يُحوَّل أي مبلغ.",
  providerDeclined: "رفضه المزوّد",
  stillPending: "لا يزال معلّقًا لدى المزوّد.",
  returnNotInOrder: "هذا الإرجاع لا يخص هذا الطلب.",
  notesSaved: "تم حفظ الملاحظات والوسوم.",
  unsubscribedSaved: "تم إلغاء الاشتراك في الرسائل التسويقية.",

  order: "الطلب",
  orderNumber: "الطلب رقم {number}",
  customer: "العميل",
  payment: "الدفع",
  fulfillment: "التنفيذ",
  reason: "السبب",
  reasonLabel: "السبب:",
  yourNote: "ملاحظتك:",
  instructionsLabel: "التعليمات:",
  note: "ملاحظة",
  internalNote: "ملاحظة داخلية",
  ofQuantity: "من {count}",
  itemFallback: "منتج",
  exportCsv: "تصدير CSV",
  exportCsvFiltered: "تصدير CSV (مُصفّى)",
  subscribed: "مشترك",
  notSubscribed: "غير مشترك",

  ordersTitle: "الطلبات",
  ordersDescription: "كل الطلبات المقدَّمة في متجرك، بما فيها الطلبات غير المدفوعة التي تنتظر الدفع.",
  searchPlaceholderPii: "رقم الطلب أو البريد الإلكتروني أو الاسم",
  searchPlaceholder: "رقم الطلب",
  anyStatus: "كل الحالات",
  anyPayment: "كل حالات الدفع",
  anyFulfillment: "كل حالات التنفيذ",
  from: "من",
  to: "إلى",
  sort: "الترتيب",
  sortNewest: "الأحدث",
  sortOldest: "الأقدم",
  sortTotalDesc: "الإجمالي: من الأعلى إلى الأدنى",
  sortTotalAsc: "الإجمالي: من الأدنى إلى الأعلى",
  noOrdersMatch: "لا توجد طلبات مطابقة",
  noOrdersMatchHint: "جرّب عوامل تصفية أو تواريخ مختلفة.",
  resetFilters: "إعادة ضبط عوامل التصفية",
  noOrdersYet: "لا توجد طلبات بعد",
  noOrdersYetHint: "عندما يُتمّ العملاء الشراء، تظهر طلباتهم هنا — بما فيها طلبات الدفع عند الاستلام والتحويل البنكي التي تنتظر الدفع.",
  colMethod: "الطريقة",
  itemCount: "{count} منتج",
  itemCount_zero: "لا منتجات",
  itemCount_one: "منتج واحد",
  itemCount_two: "منتجان",
  itemCount_few: "{count} منتجات",
  itemCount_many: "{count} منتجًا",

  placedOn: "قُدّم في {date}",
  cancelOrder: "إلغاء الطلب",
  cancelOrderTitle: "إلغاء الطلب رقم {number}؟",
  cancelPaidOnline: "تم دفع هذا الطلب ({amount} لم يُسترد بعد). الإلغاء {refundsFirst} عبر {provider}؛ ولا يُلغى الطلب إلا إذا نجح الاسترداد.",
  cancelPaidOffline: "تم دفع هذا الطلب ({amount} لم يُسترد بعد). الإلغاء {refundsFirst} (يُسجَّل كاسترداد يدوي — أعِد المبلغ بنفسك)؛ ولا يُلغى الطلب إلا إذا نجح الاسترداد.",
  refundsFirst: "يسترد الدفعة أولًا",
  cancelNoRefundRole: "لا يسمح دورك بإصدار عمليات الاسترداد، لذا لا يمكنك إلغاء طلب مدفوع.",
  cancelUnpaid: "لا توجد دفعة محصّلة لهذا الطلب. سيُحرَّر المخزون المحجوز ويُعاد أي استخدام لرمز الخصم. وسيُبلَّغ العميل.",
  restockItems: "إعادة المنتجات إلى المخزون",
  restockOrderedHint: "إعادة الكميات المطلوبة إلى المخزون.",
  orderCancelledTitle: "تم إلغاء الطلب",
  testOrderInfo: "هذا طلب في وضع الاختبار. لم يُخصم أي مبلغ حقيقي.",
  items: "المنتجات",
  colProduct: "المنتج",
  colQty: "الكمية",
  colUnit: "سعر الوحدة",
  colDiscount: "الخصم",
  colTax: "الضريبة",
  colFulfilled: "المُنفّذ",
  sku: "رمز المنتج {sku}",
  digital: "رقمي",
  restockedCount: "أُعيد {count} إلى المخزون",
  notApplicable: "غير منطبق",
  subtotal: "المجموع الفرعي",
  discount: "الخصم",
  shipping: "الشحن",
  shippingWithMethod: "الشحن ({method})",
  taxLine: "{name} {rate}%",
  taxLineIncluded: "{name} {rate}% (مشمولة)",
  tax: "الضريبة",
  taxIncluded: "الضريبة (مشمولة)",
  paid: "المدفوع",
  refunded: "المسترد",
  refundable: "القابل للاسترداد",
  customerNote: "ملاحظة العميل",
  nothingToShip: "لا يحتاج أي شيء في هذا الطلب إلى شحن.",
  shipmentN: "الشحنة {n}",
  shippedOn: "شُحنت في {date}",
  shippedOnBy: "شُحنت في {date} بواسطة {name}",
  deliveredOn: "سُلّمت في {date}",
  customerNotified: "تم إبلاغ العميل",
  markDelivered: "تمييز كمُسلَّمة",
  track: "تتبّع",
  createShipment: "إنشاء شحنة",
  shipAfterPayment: "اشحن هذا الطلب بعد تأكيد الدفع.",
  shipAfterPaymentOffline: "اشحن هذا الطلب بعد تأكيد الدفع (ميّز الدفعة كمستلَمة أولًا).",
  allFulfilled: "تم تنفيذ كل المنتجات.",
  noShipments: "لا توجد شحنات بعد.",
  refunds: "عمليات الاسترداد",
  refundsSummary: "تم استرداد {refunded} من أصل {paid} مدفوعة",
  via: "عبر {provider}",
  manualOffline: "يدوي (خارج الإنترنت)",
  providerRef: "المرجع {ref}",
  restockedN: "أُعيد {count} إلى المخزون",
  checkRefundStatus: "التحقق من حالة الاسترداد",
  refundPendingAlert: "يوجد استرداد معلّق لدى المزوّد. يُحجز مبلغه من إجمالي القابل للاسترداد حتى يكتمل أو يفشل.",
  nothingToRefund: "لم يتبقَّ شيء لاسترداده.",
  returns: "المرتجعات",
  requestedOn: "طُلب في {date}",
  timeline: "السجل الزمني",
  timelineHint: "الملاحظات داخلية ولا تُعرض على العميل أبدًا.",
  addNotePlaceholder: "أضف ملاحظة داخلية…",
  adding: "جارٍ الإضافة…",
  addNote: "إضافة ملاحظة",
  noEvents: "لا توجد أحداث بعد.",
  eventSystem: "النظام",
  eventInternalNote: "ملاحظة داخلية",
  eventInternal: "داخلي",
  eventVisible: "مرئي للعميل",
  noPaymentRecord: "لا يوجد سجل دفع.",
  captured: "المحصّل",
  paymentRef: "مرجع الدفع",
  providerReference: "مرجع المزوّد",
  checkoutRef: "مرجع صفحة الدفع",
  lastUpdate: "آخر تحديث",
  refreshFromProvider: "تحديث الحالة من المزوّد",
  codInfo: "الدفع عند الاستلام: حصّل المبلغ ثم سجّله هنا.",
  bankTransferInfo: "التحويل البنكي: ميّز الطلب كمدفوع عند وصول الأموال إلى حسابك.",
  markPaymentReceived: "تمييز الدفعة كمستلَمة",
  markPaymentReceivedTitle: "تمييز الدفعة كمستلَمة؟",
  markAsPaid: "تمييز كمدفوع",
  markPaidBody: "يسجّل {amount} كمبلغ مستلَم للطلب رقم {number}. هذا الإجراء {audited} باسمك ولا يمكن التراجع عنه — إذا كان خطأً فسيلزمك تسجيل استرداد.",
  audited: "مُسجَّل في سجل التدقيق",
  paidNoteHint: "مثلًا: مرجع التحويل أو الشخص الذي حصّل المبلغ نقدًا.",
  paidOn: "دُفع في {date}",
  guestCheckout: "شراء كضيف",
  customerOrdersSpent: "{count} طلب · أنفق {amount}",
  customerOrdersSpent_one: "طلب واحد · أنفق {amount}",
  customerOrdersSpent_two: "طلبان · أنفق {amount}",
  customerOrdersSpent_few: "{count} طلبات · أنفق {amount}",
  customerOrdersSpent_many: "{count} طلبًا · أنفق {amount}",
  shippingAddress: "عنوان الشحن",
  billingAddress: "عنوان الفوترة",
  sameAsShipping: "مطابق لعنوان الشحن",
  customerHidden: "بيانات العميل مخفية",
  customerHiddenHint: "لا يتيح دورك الوصول إلى معلومات العملاء.",

  itemsToShip: "المنتجات المراد شحنها",
  alreadyShipped: "شُحن منها {count}",
  carrier: "شركة الشحن",
  trackingNumber: "رقم التتبّع",
  trackingUrl: "رابط التتبّع",
  trackingUrlHint: "يجب أن يبدأ بـ https://",
  notifyShipping: "إرسال تأكيد الشحن إلى العميل بالبريد الإلكتروني",
  notifyShippingHint: "يتضمن تفاصيل التتبّع عند توفّرها.",
  creatingShipment: "جارٍ إنشاء الشحنة…",

  refundOnlineInfo: "يُرسَل المبلغ المسترد عبر {provider} — المزوّد الذي دفع العميل من خلاله — إلى وسيلة الدفع الأصلية. قد يستغرق ظهوره عدة أيام عمل.",
  refundOfflineInfo: "دُفع هذا الطلب عبر {provider}. الاسترداد {recorded} هنا ويحدّث إجماليات الطلب، لكن لا يُحوَّل أي مبلغ تلقائيًا — أعِد المبلغ إلى العميل بنفسك (نقدًا، تحويل بنكي…).",
  recorded: "يُسجَّل فقط",
  refundAmount: "مبلغ الاسترداد",
  refundAmountHint: "يمكن استرداد ما يصل إلى {amount}.",
  refundReasonHint: "يُحفظ في الطلب للرجوع إليه.",
  restockHint: "أعِد هذه الكميات إلى المخزون عند نجاح الاسترداد. اتركها 0 إذا كانت المنتجات لن تُعاد.",
  refunding: "جارٍ الاسترداد…",
  refundVia: "استرداد عبر {provider}",
  recordRefund: "تسجيل الاسترداد",

  approve: "موافقة",
  approveReturn: "الموافقة على الإرجاع",
  approveBody: "يُبلَّغ العميل بالموافقة على الإرجاع ويرى تعليماتك.",
  returnInstructions: "تعليمات الإرجاع",
  returnInstructionsHint: "مثلًا: أين تُرسَل المنتجات وما الذي يجب إرفاقه.",
  reject: "رفض",
  rejectReturn: "رفض الإرجاع",
  rejectBody: "سيرى العميل ملاحظتك.",
  noteToCustomer: "ملاحظة للعميل",
  markReceived: "تمييز كمُستلَم",
  markItemsReceived: "تمييز المنتجات كمُستلَمة",
  receiveBody: "يؤكد وصول المنتجات المرتجعة. يمكنك الاسترداد بعد ذلك.",
  refundReturn: "استرداد الإرجاع",
  refundThisReturn: "استرداد هذا الإرجاع",
  refund: "استرداد",
  refundReturnOnline: "يُعاد المبلغ عبر مزوّد الدفع الأصلي إلى وسيلة دفع العميل.",
  refundReturnOffline: "دفع خارج الإنترنت: يُسجَّل الاسترداد فقط — أعِد المبلغ إلى العميل بنفسك.",
  suggestedHint: "مقترح: حصة المنتجات المرتجعة من إجمالي بنودها.",
  restockReturned: "إعادة المنتجات المرتجعة إلى المخزون",
  closeReturn: "إغلاق الإرجاع",
  closeBody: "يغلق الطلب دون أي تغييرات أخرى.",

  returnsDescription: "طلبات الإرجاع التي يرسلها العملاء من صفحة طلبهم. وافق عليها واستلمها واستردّ مبالغها من هنا أو من صفحة الطلب.",
  noReturnsWithStatus: "لا توجد مرتجعات بالحالة «{status}»",
  noReturnRequests: "لا توجد طلبات إرجاع",
  noReturnsHint: "عندما يطلب عميل إرجاع منتجات، يظهر الطلب هنا.",
  suggestedRefund: "الاسترداد المقترح {suggested} · {refundable} قابل للاسترداد في الطلب",

  customersTitle: "العملاء",
  customersDescription: "الأشخاص الذين طلبوا من متجرك أو أنشؤوا حسابًا. يُنشَؤون تلقائيًا عند الدفع.",
  segmentRepeat: "عملاء متكررون",
  segmentSubscribers: "مشتركو البريد الإلكتروني",
  segmentAccounts: "لديهم حسابات",
  segmentNoOrders: "بلا طلبات",
  customerSearchPlaceholder: "الاسم أو البريد الإلكتروني أو الهاتف",
  tag: "وسم",
  exactTag: "وسم مطابق تمامًا",
  noCustomersMatch: "لا يوجد عملاء مطابقون",
  noCustomersMatchHint: "جرّب بحثًا أو وسمًا أو شريحة أخرى.",
  showAll: "عرض الكل",
  noCustomersYet: "لا يوجد عملاء بعد",
  noCustomersYetHint: "يظهر العملاء هنا بعد طلبهم الأول أو عند إنشاء حساب في متجرك.",
  colOrders: "الطلبات",
  colSpent: "المبلغ المُنفَق",
  colMarketing: "التسويق",
  colLastOrder: "آخر طلب",

  account: "حساب",
  guest: "ضيف",
  customerSince: "عميل منذ {date}",
  totalSpent: "إجمالي الإنفاق",
  avgOrder: "متوسط الطلب",
  showing50: "يُعرض أحدث 50 طلبًا.",
  refundedAmount: "−{amount} مسترد",
  notesTags: "الملاحظات والوسوم",
  notesTagsHint: "داخلية — لا تُعرض على العميل أبدًا.",
  tags: "الوسوم",
  tagsHint: "اضغط Enter أو فاصلة للإضافة. استخدم الوسوم لتصفية العملاء.",
  noTags: "لا توجد وسوم",
  noNote: "لا توجد ملاحظة",
  contact: "بيانات الاتصال",
  hasStoreAccount: "لديه حساب في المتجر",
  guestNoPassword: "ضيف (بدون كلمة مرور)",
  emailMarketing: "التسويق عبر البريد الإلكتروني",
  consentGiven: "تاريخ الموافقة",
  unsubscribed: "تاريخ إلغاء الاشتراك",
  optInInfo: "العملاء وحدهم يمكنهم الاشتراك، عند الدفع أو من حسابهم. يمكنك إلغاء اشتراكهم بناءً على طلبهم، لكن لا يمكنك اشتراكهم.",
  unsubscribeFromMarketing: "إلغاء الاشتراك في التسويق",
  unsubscribeTitle: "إلغاء اشتراك هذا العميل؟",
  unsubscribe: "إلغاء الاشتراك",
  unsubscribeBody: "سيتوقف عن تلقّي الرسائل التسويقية. لا تتأثر رسائل الطلبات والشحن. العميل وحده يمكنه الاشتراك من جديد.",
  addresses: "العناوين",
  noSavedAddresses: "لا توجد عناوين محفوظة.",
  defaultAddress: "افتراضي",
};

export default ar;
